import { Tiers } from '../constants/tiers';
import { BILLING_BRAND_REMOVE } from '../constants/features';

export const canUseFeatureByTier = (featureName, accountTier) => {
  const minimunTier = getFeatureMinimumTier(featureName);

  const accountIndexTier = Tiers.ORGANIZED_TIERS.indexOf(accountTier);
  const minimunIndexTier = Tiers.ORGANIZED_TIERS.indexOf(minimunTier);

  return accountIndexTier >= minimunIndexTier;
};

const FEATURES_TIERS = {
  [BILLING_BRAND_REMOVE]: Tiers.ALL_TIERS.PRO,
};

const getFeatureMinimumTier = (featureName) => {
  // Fallback for non-implemented features to lowest tier
  return FEATURES_TIERS[featureName] || Tiers.ALL_TIERS.FREE;
};
